export const COLOR_THEME_SUPPORTED_DOMAINS = ["freedemokit.com", "betspiper.com", "winfair24.com"] as const;
